import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const logoUrl = process.env.PUBLIC_URL + '/connect-lane-logo.png';

const PARTNER_NAMES = [
  'Zenvoya Remit', 'PaySutra Global', 'RemitRaah', 'TransFeriya', 'Virexa Send',
  'MoneyMitra Exchange', 'Corrivana Transfers', 'SendSaffron', 'GlobeDhan Connect', 'RemitPeeth',
  'FlowDesh Payments', 'Nexora Remit', 'BridgeLoom Pay', 'SwiftSetu', 'RemitMosaic',
  'PayParivar Crossborder', 'LumenLanka Transfers', 'BorderLeaf Remit', 'CoinYatra', 'BlueSettle Global'
];

const LandingPage = () => {
  const carouselRef = useRef(null);

  const handleCarouselRotate = (direction) => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    
    const scrollAmount = 300;
    if (direction === 'left') {
      carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="landing-page">
      <nav className="landing-nav">
        <div className="nav-container">
          <Link to="/" className="logo-link landing-logo">
            <img src={logoUrl} alt="Connect Lane" className="nav-logo-img" />
            <span className="logo-brand"><span className="brand-connect">Connect</span> <span className="brand-lane">Lane</span></span>
          </Link>
          <div className="nav-links">
            <Link to="/login" className="nav-link">Login</Link>
            <Link to="/signup" className="nav-link btn-primary">Sign Up</Link>
          </div>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-content">
          <h1>Unified Remittance API Platform</h1>
          <p className="hero-subtitle">
            Connect with multiple remittance partners through a single, standardized API.
            Integrate with Zenvoya Remit, PaySutra Global, RemitRaah, TransFeriya, and more.
          </p>
          <div className="hero-buttons">
            <Link to="/signup" className="btn btn-green btn-large">Get Started</Link>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2>Key Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🔌</div>
              <h3>Multiple Partners</h3>
              <p>Integrate with Zenvoya Remit, PaySutra Global, RemitRaah, TransFeriya and other remittance providers</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔑</div>
              <h3>Unified API</h3>
              <p>Single standardized API interface for all partner integrations</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Dashboard & Analytics</h3>
              <p>Monitor payments, customers, and compliance from one central dashboard</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h3>KYC & Compliance</h3>
              <p>Built-in KYC verification and compliance management tools</p>
            </div>
          </div>
        </div>
      </section>

      <section className="partners-section">
        <div className="container">
          <h2>Our Partners</h2>
          <div className="partners-carousel">
            <button className="carousel-btn carousel-btn-left" onClick={() => handleCarouselRotate('left')}>‹</button>
            <div className="partners-grid" ref={carouselRef}>
              {PARTNER_NAMES.map((name) => (
                <div key={name} className="partner-logo-item">
                  <span className="partner-name-text">{name}</span>
                </div>
              ))}
            </div>
            <button className="carousel-btn carousel-btn-right" onClick={() => handleCarouselRotate('right')}>›</button>
          </div>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="container footer-content">
          <img src={logoUrl} alt="Connect Lane" className="footer-logo-img" />
          <p><span className="brand-connect">Connect</span> <span className="brand-lane">Lane</span> &copy; 2026. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
